/**
 * @namespace transform/array
 * @see module:@kids/lib/transform/array
 */

/**
 * @module @kids/lib/transform/array
 * @see transform/array
 * @desc Stellt alle puren Funktionen zur Array-Umwandlung zur Verfügung.
 * @example
 * import {clone, shuffle} from '@kids/lib/transform/array';
 *
 * const array1 = [0, 1, 2, 3];
 * const array2 = shuffle(clone(array1));
 */

const {Math} = globalThis;

/** Klont ein Array - bedenke: wenn sich im Array weitere Referenzobjekte befinden, werden diese aber nicht kopiert.
 * @alias transform/array.clone
 * @param {Array} array
 * @returns {Array}
 */
export function clone(array)
{
    return array.slice(0);
}

/** Ordnet die Elemente eines Arrays per Zufall neu an.
 * @alias transform/array.shuffle
 * @param {Array} array
 * @returns {Array}
 */
export function shuffle(array)
{
    const {length} = array;
    if (length)
    {
        let top = length;
        let tmp = length;
        let current = length;
        while (--top)
        {
            current = Math.floor(Math.random() * (top + 1));
            tmp = array[current];
            array[current] = array[top];
            array[top] = tmp;
        }
    }
    return array;
}

/** Liefert ein neues Array zurück, im welchem alle Vorkommen des übergebenen Werts gelöscht sind.
 * @alias transform/array.clear
 * @param {Array} array
 * @param {*} valueToClear - Wert, welcher aus dem Array gelöscht werden soll
 * @returns {Array}
 */
export function clear(array, ...valuesToClear)
{
    const newArray = [];
    let i = array.length;
    while (i--)
    {
        if (valuesToClear.includes(array[i])) { continue; }
        newArray.push(array[i]);
    }
    return newArray.reverse();
}

/** Liefert ein neues Array zurück, in welchem in jeder Wert einmalig ist
 * @alias transform/array.unique
 * @param {Array} array
 * @returns {Array}
 */
export function unique(array)
{
    const newArray = [];
    const {length} = array;
    for (let i = 0; i < length; i++)
    {
        if (!newArray.includes(array[i]))
        {
            newArray.push(array[i]);
        }
    }
    return newArray;
}
